import {Directive, TemplateRef} from '@angular/core';

@Directive({ selector: '[storeverDatatableColumnCell]' })
export class DataTableColumnCellDirective {
  constructor(public template: TemplateRef<any>) {}
}
